import EventEmitter from "eventemitter3";

const eventEmitter = new EventEmitter();

const Emitter = {
  on: (key: string, callback: (...args: any[]) => void): EventEmitter =>
    eventEmitter.on(key, callback),
  once: (key: string, callback: (...args: any[]) => void): EventEmitter =>
    eventEmitter.once(key, callback),
  off: (key: string, callback: (...args: any[]) => void): EventEmitter =>
    eventEmitter.off(key, callback),
  emit: (key: string, context: any): boolean => eventEmitter.emit(key, context),
};

Object.freeze(Emitter);

export default Emitter;
